<script setup lang="ts">
import Table from '../components/Table.vue'
</script>

<template>
    <Table />
</template>
